// src/components/ProfileForm.jsx
import { useMediaQuery } from "@mui/material";
import ProfileFormDesktop from "./ProfilFormDesktop";
import ProfileFormMobile from "./ProfileFormMobile";

export default function ProfileForm() {
  // Pour écrans larges (>= 768px) on affiche la version desktop
  const isDesktop = useMediaQuery("(min-width:768px)");
  return isDesktop ? <ProfileFormDesktop /> : <ProfileFormMobile />;
}
